import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, NumberValueAccessor } from '@angular/forms';
import { NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject, Subscription } from 'rxjs';
import { FilterProjectDto } from 'src/app/web/interfaces/project/list/filterProjectDto';
import { FilterProjectInfoDto } from 'src/app/web/interfaces/project/list/filterProjectInfoDto';
import { FilterProjectInfoFrenteDto } from 'src/app/web/interfaces/project/list/filterProjectInfoFrenteDto';
import { ViewProjectPayDto } from 'src/app/web/interfaces/project/list/viewProjectPayDto';
import { FilterProjectStadoDto } from 'src/app/web/interfaces/project/list/filterProjectStadoDto';
import { ViewProject } from 'src/app/web/interfaces/project/list/viewProjectDto';
import { DropdownSettingsStado, FormatDataTableGlobal } from 'src/app/web/util/formatDataTable';
import Swal from 'sweetalert2/dist/sweetalert2.js'; 
import { ApiServiceProject } from '../../../apis/ApiServiceProject';
import { Router, ActivatedRoute } from '@angular/router';
import { ErrorService } from 'src/app/shared/services/errors.service';


export class listPay {

  action:number;
  description:string;
  username:string;
  created:string;

}

export class infolistPay {

  id: number;
  title: string;
  scheduled_date: string;
  rescheduled_date: string;
  real_date: string;
  status: string;
  anexo: string;
  name: string;
  pay_amount: string;
  amount_percent: string;


}

@Component({
  selector: 'app-pay-history-project',
  templateUrl: './pay-history-project.component.html',
  styleUrls: ['./pay-history-project.component.scss']
})
export class PayHistoryProjectComponent implements AfterViewInit, OnDestroy, OnInit {

  @ViewChild(DataTableDirective, {static: false})
  dtElement: DataTableDirective;
  dtTrigger = new Subject();
  dtOptions: DataTables.Settings = {};
  idProject: number;
  id_pay: number;
  name: string;
  infoPayForm: FormGroup;
  private apiService: ApiServiceProject;
  idSubscription: Subscription;
  searchForm: FormGroup;
  ListPay: listPay[] = []
  listViewProjectDto: ViewProject[] = []
  listViewProjectDtoBack: ViewProject[] = []
  filterProjectInfoDto: FilterProjectInfoDto = {} as FilterProjectInfoDto
  filterProjectInfoFrenteDto: FilterProjectInfoFrenteDto[] = []
  filterProjectDto: FilterProjectDto = {} as FilterProjectDto;
  selectedItems = [];
  dropdownSettings = {};
  opcionClient = 0
  opcionFrete = 0
  opcionSeleccionado = "todo"
  datos: infolistPay = {} as infolistPay;

  constructor(private http: HttpClient,
    private spinner: NgxSpinnerService,
    config: NgbDropdownConfig,
    private fb: FormBuilder,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private errorService:ErrorService
  ) 
    {
      config.placement = 'bottom';
      this.idSubscription = this.activatedRoute.params.subscribe(params => {
        this.id_pay = params['id'];
        this.name = params['name'];
        return this.idProject = params['id_project'];
        
      })
    }

  ngOnInit(): void {

    this.dtOptions = FormatDataTableGlobal();
    this.apiService =  new ApiServiceProject(this.http);

    let rs = JSON.parse(localStorage.getItem("info-mtn"));
   
    rs.listProjectPlay.map((dato) => {
      if (dato.id == this.id_pay) {
        this.datos = dato;
      }
    })

    this.spinner.show();

    this.apiService.getService('list-project-play-history?id=' + this.id_pay).subscribe({
      next: (rs:any) => {

        if (rs.code == null) {
          // si la respuesta no tiene error pero no tiene data se manda un mensaje de error y se retorna al home
          if (rs == '' || rs == null) {
            this.spinner.hide();
            Swal.fire({
              title: 'No se encontraron registros',
              text: '',
              icon: 'info',
              confirmButtonText: 'Aceptar',
              heightAuto: false
            }).then((res) => {
              if (res.isConfirmed || res.isDismissed) {
                this.router.navigate(['home']);
              }
            });
          }
          this.ListPay = rs.listProjectPlayHistory;
          this.rerender();
          this.spinner.hide();
        } else {
          
          this.spinner.hide();
          Swal.fire({
          title:  rs.error,
          text: '',
          icon: 'error',
          heightAuto: false
          });
        }
      },
      error: (error) => {
        this.errorService.error(error);
      },
    });

  }

  onItemSelect(item: any) {
    
  }


  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }

  projectDetails(id: number) {
    this.spinner.show();
    this.router.navigate([`/pdg/project/list/view/${id}`]);
  }

  stageAnularPay(id:any){
    Swal.fire({
              title: 'Anular',
              text: '¿Desea Anular el pago?',
              icon: 'warning',
              showCancelButton:true,
              confirmButtonText: 'Aceptar',
              cancelButtonText:"No, cancelar",
              heightAuto: false
            }).then((res) => {
              if (res.isConfirmed) {
                this.spinner.show()
                this.apiService.putService('anular-project-play?id=' + id).subscribe({
                  next: (rs: any) => {
                    if (rs) {
                      this.spinner.hide();
                      Swal.fire({title:'Exito!',text:'Se ha anulado con exito!',icon: 'success',heightAuto: false}).then(()=>{location.reload()})
                      
                    } else {
                        this.spinner.hide();
                        Swal.fire({
                        title:  rs.error,
                        text: '',
                        icon: 'error',
                        heightAuto: false
                        }); } },
                  error: (error) => {
                    this.errorService.error(error);
                  },});
              }
              else if ( res.dismiss === Swal.DismissReason.cancel){
                Swal.fire({
                  title: 'Cancelado',
                  text: 'Operación cancelada.',
                  icon: 'error',
                  heightAuto: false
                  })

              }
            });


  }

  stageDeletePay(id:any){
    Swal.fire({
              title: 'Eliminar',
              text: '¿Desea Anular el pago?',
              icon: 'error',
              showCancelButton:true,
              confirmButtonText: 'Aceptar',
              cancelButtonText:"No, cancelar",
              heightAuto: false
            }).then((res) => {
              if (res.isConfirmed) {
                this.spinner.show()
                this.apiService.deleteService('delete-project-play?id=' + id).subscribe({
                  next: (rs: any) => {
                    if (rs) {
                      this.spinner.hide();
                      Swal.fire({title:'Exito!',text: 'Se ha eliminado con exito!',icon: 'success',heightAuto: false}).then(()=>{location.reload()})
                      
                    } else {
                        this.spinner.hide();
                        Swal.fire({
                        title:  rs.error,
                        text: '',
                        icon: 'error',
                        heightAuto: false
                        }); } },
                  error: (error) => {
                    this.errorService.error(error);
                  },});
              }
              else if ( res.dismiss === Swal.DismissReason.cancel){
                Swal.fire({
                  title: 'Cancelado',
                  text: 'Operación cancelada.',
                  icon: 'error',
                  heightAuto: false
                  })

              }
            });


  }

  stageCancelPay(id:any){
    Swal.fire({
              title: 'Cancelar Pago',
              text: '¿Desea cancelar el pago?',
              icon: 'warning',
              showCancelButton:true,
              confirmButtonText: 'Aceptar',
              cancelButtonText:"No, cancelar",
              heightAuto: false
            }).then((res) => {
              if (res.isConfirmed) {
                this.spinner.show()
                this.apiService.deleteService('cancel-project-play?id=' + id).subscribe({
                  next: (rs: any) => {
                    if (rs) {
                      this.spinner.hide();
                      Swal.fire({title:'Exito!',text:'Se ha cancelado con exito!',icon: 'success',heightAuto: false}).then(()=>{location.reload()})
                      
                    } else {
                        this.spinner.hide();
                        Swal.fire({
                        title:  rs.error,
                        text: '',
                        icon: 'error',
                        heightAuto: false
                        }); } },
                  error: (error) => {
                    this.errorService.error(error);
                  },});
              }
              else if ( res.dismiss === Swal.DismissReason.cancel){
                Swal.fire({
                  title: 'Cancelado',
                  text: 'Operación cancelada.',
                  icon: 'error',
                  heightAuto: false
                  })

              }
            });


  }

  Pagos(enable: number, id: number, name: string) {

    if (enable == 1) {
      this.spinner.show();
    this.router.navigate([`/pdg/project/pay/list/${id}/${name}`]);
    }
  }

  valideNegative(monto){
    if(monto.toString().includes("-")){
      return true
    }
    return false
  }

}
